(function () {
  'use strict';

  function prepareVideo(video) {
    if (!video || video.tagName !== 'VIDEO') return;

    video.defaultMuted = true;
    video.muted = true;
    video.playsInline = true;
    video.autoplay = true;
    video.loop = true;
    video.controls = false;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('autoplay', '');
    video.setAttribute('loop', '');
    video.removeAttribute('controls');
    video.setAttribute('controlsList', 'nodownload nofullscreen noremoteplayback');
    video.setAttribute('disablepictureinpicture', '');

    if (video.preload === 'none') {
      video.preload = 'metadata';
    }
  }

  function playVideo(video) {
    prepareVideo(video);

    var playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        /* Safari may defer autoplay until the next frame or scroll */
      });
    }
  }

  function pauseVideo(video) {
    if (!video || video.tagName !== 'VIDEO') return;
    if (!video.paused) {
      video.pause();
    }
  }

  function isVideoVisible(video) {
    var rect = video.getBoundingClientRect();
    if (rect.width <= 0 || rect.height <= 0) return false;

    var viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    var viewportHeight = window.innerHeight || document.documentElement.clientHeight;

    return rect.right > 0 && rect.left < viewportWidth && rect.bottom > 0 && rect.top < viewportHeight;
  }

  function initGallery(section) {
    var videos = Array.prototype.slice.call(section.querySelectorAll('.rabitat-video-gallery__video'));
    if (!videos.length) return;

    videos.forEach(prepareVideo);

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
              playVideo(video);
            } else {
              pauseVideo(video);
            }
          });
        },
        {
          root: section.querySelector('[data-collection-viewport]') || null,
          threshold: [0, 0.2, 0.45],
          rootMargin: '0px 120px',
        }
      );

      videos.forEach(function (video) {
        observer.observe(video);
        if (isVideoVisible(video)) {
          playVideo(video);
        }
      });
    } else {
      videos.forEach(playVideo);
    }

    section.addEventListener(
      'scroll',
      function () {
        videos.forEach(function (video) {
          if (isVideoVisible(video)) {
            playVideo(video);
          }
        });
      },
      true
    );
  }

  function resumeVisibleVideos() {
    document.querySelectorAll('.rabitat-video-gallery').forEach(function (section) {
      section.querySelectorAll('.rabitat-video-gallery__video').forEach(function (video) {
        if (isVideoVisible(video)) {
          playVideo(video);
        }
      });
    });
  }

  function init() {
    document.querySelectorAll('.rabitat-video-gallery').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.rabitat-video-gallery') || event.target.closest('.rabitat-video-gallery');
    if (section) initGallery(section);
  });

  document.addEventListener('visibilitychange', function () {
    if (document.hidden) {
      document.querySelectorAll('.rabitat-video-gallery__video').forEach(pauseVideo);
      return;
    }

    resumeVisibleVideos();
  });

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      resumeVisibleVideos();
    }
  });
})();
